import API from './api'

export default class Modals {
  constructor() {
    this.triggers = document.querySelectorAll('[data-modal]')
    this.active = null
    this.form = null

    if (!this.triggers) return

    this.initHandlers()
    this.initTriggers()
  }

  initHandlers() {
    const close = (e) => {
      const valid =
        e.key == 'Escape' ||
        e.target.closest('.is-exit') ||
        e.target.classList.contains('modal-background')

      if (valid && this.active) {
        if (this.form && this.formSubmitHandlerBound) {
          this.modalContent.removeEventListener(
            'submit',
            this.formSubmitHandlerBound
          )

          this.formSubmitHandlerBound = null
        }

        this.active.classList.remove('is-active')
        this.active.setAttribute('aria-hidden', 'true')
        this.active.removeEventListener('click', this.closeHandler)

        document.documentElement.classList.remove('is-clipped')
        document.removeEventListener('keyup', this.closeHandler)

        this.active = null
      }
    }

    this.closeHandler = close.bind(this)
  }

  initTriggers() {
    this.triggers.forEach((e) => {
      e.addEventListener('click', () => {
        const modal = document.querySelector(
          '.modal[data-id=' + e.dataset.modal + ']'
        )

        if (modal) {
          this.active = modal

          document.documentElement.classList.add('is-clipped')
          document.addEventListener('keyup', this.closeHandler)

          this.active.classList.add('is-active')
          this.active.setAttribute('aria-hidden', 'false')
          this.active.addEventListener('click', this.closeHandler)

          if (this.active.dataset.form) {
            this.initForm()
          }
        }
      })
    })
  }

  async initForm() {
    this.modalContent = this.active.querySelector('main')
    const response = await API.getFeedbackForm(this.active.dataset.form)

    this.modalContent.innerHTML = response
    this.form = this.modalContent.querySelector('form')

    if (this.form) {
      this.formSubmitHandlerBound = this.formSubmitHandler.bind(this)
      this.modalContent.addEventListener('submit', this.formSubmitHandlerBound)
    }

    this.renderTurnstile()
  }

  // The feedback form is injected after page load, so the Turnstile widget
  // has to be rendered explicitly (the implicit scan only runs once, on load).
  renderTurnstile(attempt = 0) {
    const el = this.modalContent.querySelector('#feedback-turnstile')
    if (!el || el.dataset.rendered) return

    if (!window.turnstile) {
      // api.js is async — retry briefly until it's available.
      if (attempt < 20) setTimeout(() => this.renderTurnstile(attempt + 1), 150)
      return
    }

    window.turnstile.render(el, { sitekey: el.dataset.sitekey })
    el.dataset.rendered = 'true'
  }

  async formSubmitHandler(e) {
    e.preventDefault()

    this.form = this.modalContent.querySelector('form')
    const formData = new FormData(this.form)
    const response = await API.submitFeedbackForm(
      this.active.dataset.form,
      formData
    )

    this.modalContent.innerHTML = response
    // Re-render the widget when the server bounces the form back (a fresh
    // token is needed — Turnstile tokens are single-use).
    this.renderTurnstile()
  }
}
